import { ChatState } from 'app/models/chat/chatState.ts';
import type { RootState } from 'app/reducers/index.ts';

function create<T>(selector: (state: RootState['audioChat']) => T): (state: RootState) => T {
  return (state: RootState) => selector(state.audioChat);
}

export const audioChatSelector = create((s) => s);
export const transcriptSelector = create(s => s.transcript);
export const chatStateSelector = create(s => s.chatState);
export const isListeningSelector = create(s => s.chatState === ChatState.Listening);
export const isTranslatingSelector = create(s => s.chatState === ChatState.Translating);
export const isSpeakingSelector = create(s => s.chatState === ChatState.Speaking);
export const isReadySelector = create(s => s.chatState === ChatState.Listening || s.chatState === ChatState.Idle);
export const isRecordingSelector = create(s => s.isRecording);
export const sessionIdSelector = create(s => s.sessionId);
export const currentPersonaSelector = create(s => s.currentPersona);
export const currentAvatarUrlSelector = create(s => s.currentAvatarUrl);
export const isPlayingIntroSelector = create(s => s.isPlayingIntro);
export const lastBlockIdSelector = create(s => s.lastBlockId);
export const blockHistorySelector = create(s => s.blockHistory);
export const isChatActive = create(s => s.sessionId || s.isPlayingIntro);

